import { render, staticRenderFns } from "./RedesView.vue?vue&type=template&id=4d69bb23&scoped=true"
import script from "./RedesView.vue?vue&type=script&lang=js"
export * from "./RedesView.vue?vue&type=script&lang=js"
import style0 from "./RedesView.vue?vue&type=style&index=0&id=4d69bb23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d69bb23",
  null
  
)

export default component.exports